import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

export default class StorybookIndexRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};

		document.body.id = 'page-storybook';

		promises.initialRequests = this.navigationService.initialRequestsPromise;

		return hashSettled(promises);
	}
}
